import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import Select from "./elements/Select"
import { MOBILE } from '.././config'

import { SIDEBAR_ID } from "../config"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            // for={lableFor}
            for={SIDEBAR_ID}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center ${className}`}
        >
            <Icon name="filter" />
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )}
        </label>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <>
                {/* <div class="the-selected-filters debug-border-red ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                    <ToggleMobileSidebarButton
                        lableFor={lableFor}
                        lableFor={SIDEBAR_ID}
                        selectedFiltersCount={selectedFiltersCount}
                    />
                    <Select
                        value={activeSort}
                        onChange={e => handleSortChange(e)}
                        className="ns-selection-dropdown-sort-menu"
                        options={options}
                    />
                </div> */}
                {/* <div class="clear-all-container"> */}
                    <a
                        href="javascript:void(0)"
                        // class="ns-col-2 ns-text-undecorated ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto clear-all-filters"
                        class="ns-col-2 ns-text-undecorated ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto clear-all-filters"
                        onClick={() => {
                            removeAll()
                        }}
                    >
                        Clear All
                    </a>
                {/* </div> */}
                {/* <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2 selected-filters-margin-top selected-filters-add-bottom"> */}
                {/* <div class={`ns-d-flex ns-flex-wrap ns-align-items-center ${MOBILE ? '' : 'ns-pl-2 ns-pr-2'} ns-pt-2 ns-pb-2 selected-filters-margin-top selected-filters-add-bottom`}> */}
                <div class={`ns-d-flex ns-flex-wrap ns-align-items-center ns-pt-2 ns-pb-2 selected-filters-margin-top selected-filters-add-bottom`}>
                    {/* <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center"> */}
                    {/* <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center flex-column-mobile"> */}
                    {/* <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center flex-column-mobile"> */}
                    {/* <div class={`ns-d-flex ns-flex-wrap ns-align-items-center flex-column-mobile ${MOBILE ? 'w-100' : 'ns-col-10'}`}> */}
                    <div class={`ns-d-flex ns-flex-wrap ns-align-items-center flex-column-mobile w-100`}>
                        {filters.map(filter => (
                            <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-px-1 ns-mr-1 ns-mb-1 ns-font-4">
                                <span class="ns-color-black">
                                    {filter.name}: {filter.value}
                                </span>
                                <FilterRemoveButton filter={filter} />
                            </div>
                        ))}
                    </div>
                </div>
            </>
        )
    )
}



// mon aug 26
// {/* <>
// {/* <div class="the-selected-filters debug-border-red ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
//     <ToggleMobileSidebarButton
//         lableFor={lableFor}
//         lableFor={SIDEBAR_ID}
//         selectedFiltersCount={selectedFiltersCount}
//     />
//     <Select
//         value={activeSort}
//         onChange={e => handleSortChange(e)}
//         className="ns-selection-dropdown-sort-menu"
//         options={options}
//     />
// </div> */}
// <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2 selected-filters-margin-top">
//     <div class="ns-col-10 ns-d-flex ns-flex-wrap ns-align-items-center">
//         {filters.map(filter => (
//             <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-px-1 ns-mr-1 ns-mb-1 ns-font-4">
//                 <span class="ns-color-black">
//                     {filter.name}: {filter.value}
//                 </span>
//                 <FilterRemoveButton filter={filter} />
//             </div>
//         ))}
//     </div>
//     <a
//         href="javascript:void(0)"
//         class="ns-col-2 ns-text-undecorated ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto clear-all-filters"
//         onClick={() => {
//             removeAll()
//         }}
//     >
//         Clear All
//     </a>
// </div>
// </> */}